module.exports = __webpack_public_path__ + "static/media/flag-co.e261e729.webp";